import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import HrApp from "./HrApp";

import AuthProvider from "./components/initialpage/contexts/AuthProvider";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
// import Demo from './Demo';
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";

import StoreApp from "./StoreApp";
import store, { store1 } from "./components/initialpage/hooks/Store";

let persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    {/* <Demo></Demo> */}
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <AuthProvider>
          <BrowserRouter >
            <App />
          </BrowserRouter>
        </AuthProvider>
        {/* <AuthProvider>
          <BrowserRouter basename="hr">
          <HrApp />
        </BrowserRouter>
      </AuthProvider> */}

        {/* <AuthProvider>
          <BrowserRouter>
            <StoreApp />
          </BrowserRouter>
        </AuthProvider> */}
      </PersistGate>
    </Provider>
  </React.StrictMode >,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
